import { render, staticRenderFns } from "./FundosInvestors.vue?vue&type=template&id=d76bf7b4&scoped=true"
import script from "./FundosInvestors.vue?vue&type=script&lang=js"
export * from "./FundosInvestors.vue?vue&type=script&lang=js"
import style0 from "./FundosInvestors.vue?vue&type=style&index=0&id=d76bf7b4&prod&scoped=true&lang=css"
import style1 from "./FundosInvestors.vue?vue&type=style&index=1&id=d76bf7b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76bf7b4",
  null
  
)

export default component.exports